/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from "react";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import { process } from "@progress/kendo-data-query";

const initialDataState = { sort: [{ field: "code", dir: "asc" }] };

function AtmReconciliationsReport({ data }: { data: any[] }) {
  const [dataState, setDataState] = useState<any>(initialDataState);

  return (
    <Grid
      data={process(
        data.map((req) => ({
          ...req,
        })),
        dataState
      )}
      {...dataState}
      onDataStateChange={(e) => {
        setDataState(e.dataState);
      }}
    >
      <Column
        field="serialNo"
        title="Sr. #"
        width="60px"
        className="grid-cell-font-size text-center"
      />
      <Column
        field="customer"
        title="Customer"
        width="180px"
        className="grid-cell-font-size"
      />
      <Column
        field="locationId"
        title="Location Id"
        width="140px"
        className="grid-cell-font-size"
      />
      <Column
        field="locationName"
        title="Location Name"
        width="200px"
        className="grid-cell-font-size"
      />
      <Column
        field="machineType"
        title="Machine Type"
        width="150px"
        className="grid-cell-font-size"
      />
      <Column
        field="maker"
        title="Maker"
        width="100px"
        className="grid-cell-font-size"
      />
      <Column
        field="replenishDate"
        title="Replenish Date"
        width="150px"
        className="grid-cell-font-size"
      />
      <Column
        field="residualDate"
        title="Residuals Date"
        width="150px"
        className="grid-cell-font-size"
      />

      <Column
        field="denomination"
        title="Denomination"
        width="130px"
        className="grid-cell-font-size"
      />
      <Column
        field="count"
        title="Notes"
        width="100px"
        className="grid-cell-font-size"
      />
      <Column
        field="amount"
        title="Amount"
        width="130px"
        className="grid-cell-font-size"
      />
      <Column
        field="type"
        title="Type"
        width="100px"
        className="grid-cell-font-size"
      />
      <Column
        field="nature"
        title="Nature"
        width="100px"
        className="grid-cell-font-size"
      />
      <Column
        field="remarks"
        width="140px"
        title="Remarks"
        className="grid-cell-font-size"
      />
    </Grid>
  );
}

export default React.memo(AtmReconciliationsReport);
